import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";
import {
  UPDATE_REQUEST,
  EMAIL_UPDATE_REQUEST,
  SPECILITY_BY_ID_REQUEST,
  updateSuccess,
  updateError,
  emailUpdateSuccess,
  emailUpdateError,
  specilityByIdSuccess,
  specilityByIdError,
} from "./actions";

import { saveAuthData } from "../utils/auth/authData";
import { Env } from "../../env";

function* updateRequest(action) {
  const { id, values, userId } = action;
  let response;
  try {
    response = yield call(
      axios.patch,
      `${Env.BASE_API_URL}/Accounts/${userId}`,
      {
        birthdate: values.birthdate == "" ? "" : values.birthdate,
        firstName: values.firstName || "",
        lastName: values.multiDoctorNames
          ? values.multiDoctorNames
          : values.lastName || "",
        multiDoctorNames: values.multiDoctorNames || "",
        companyname: values.companyname == "" ? "" : values.companyname,
        companynumber: values.companynumber == "" ? "" : values.companynumber,
        phonenumber: values.phonenumber == "" ? "" : values.phonenumber,
        postaladdress: values.postaladdress == "" ? "" : values.postaladdress,
        appointmenturl:
          values.appointmenturl == "" ? "" : values.appointmenturl,
        otherurl: values.otherurl == "" ? "" : values.otherurl,
      },
      { headers: { Authorization: id } }
    );
  } catch (err) {
    let error;

    if (err.response && err.response.status === 401) {
      console.log("dshf", err);
      error = "Email ou mot de passe incorrect.";
    } else if (
      err.response &&
      err.response.status === 422 &&
      err.response.data &&
      err.response.data.error &&
      err.response.data.error.name === "ValidationError"
    ) {
      error = err.response.data.error.details.messages;
      error = JSON.stringify(error);
      yield put(updateError(error));
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
      yield put(updateError(error));
    }
    return;
  }
  const authData = response.data;
  yield put(updateSuccess(authData));
  // yield put(push('/login'));
  yield put(flashMessage("Coordonnées mises à jour", { timeout: 5000 }));
}

export function* watchUserProfileUpdateRequest() {
  yield takeLatest(UPDATE_REQUEST, updateRequest);
}

function* emailUpdateRequest(action) {
  const { id, email, userId } = action;
  let response;
  try {
    response = yield call(
      axios.post,
      `${Env.BASE_API_URL}/Accounts/editemail`,
      {
        email: email,
      },
      {
        headers: { Authorization: id },
      }
    );
  } catch (err) {
    let error;
    console.log(err.response);
    if (err.response && err.response.status === 401) {
      console.log("dshf", err);
      error = "Email ou mot de passe incorrect.";
    } else if (
      err.response &&
      err.response.status === 422 &&
      err.response.data &&
      err.response.data.error &&
      err.response.data.error.name === "ValidationError"
    ) {
      error = err.response.data.error.details.messages;
      error = JSON.stringify(error);
      yield put(emailUpdateError(error));
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
      yield put(emailUpdateError(error));
    }
    return;
  }
  const authData = response.data;
  //console.log('email',authData);
  yield put(authData);
  // console.log(emailUpdateSuccess'in signup request---->');
  yield put(push("/login"));
  yield put(
    flashMessage(
      "Veuillez s'il vous plaît vérifier vos emails afin de compléter votre inscription",
      { timeout: 5000 }
    )
  );
}
export function* watchUserProfileEmailUpdateRequest() {
  yield takeLatest(EMAIL_UPDATE_REQUEST, emailUpdateRequest);
}

function* specilityIdByRequest(action) {
  let response1;
  try {
    response1 = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Specialities/${action.id}`
    );
  } catch (err) {
    let error;

    if (
      err.response1 &&
      err.response1.status === 422 &&
      err.response1.data &&
      err.response1.data.error &&
      err.response1.data.error.name === "ValidationError"
    ) {
      error = err.response1.data.error.details.messages;
      error = JSON.stringify(error);
      yield put(specilityByIdError(error));
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
      yield put(specilityByIdError(error));
    }
    return;
  }
  const authData = response1.data;
  //saveAuthData(authData);
  //console.log('sdd',authData);
  yield put(specilityByIdSuccess(authData));
}
export function* watchSpecilityByIdRequest() {
  yield takeLatest(SPECILITY_BY_ID_REQUEST, specilityIdByRequest);
}



// WEBPACK FOOTER //
// ./src/pages/userprofile/saga.js